import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_PATIENTS_NEW_RESULTS_URL } from "@/core/urls";
import { ORGANISATION_USER_TESTS_FOR_REVIEW_QUERY } from "@/graphql/organisations/queries/patients";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import ChartIcon from "@/images/ChartIcon";
import ChevronComponent from "@/tpo/Chevron";
import LinkWrapper from "@/tpo/LinkWrapper";
import ButtonV2 from "@/v2/Buttons";
import { useQuery } from "@apollo/client";

import DashboardPanel from "../DashboardPanel";
import ResultsToViewList from "./ResultsToViewList";
import {
  cmpHomeDashboardListPageSize,
  cmpHomeDashboardPanelPadding,
  cmpHomeDashboardPanelTitleProps,
  cmpHomeDashboardScrollableListBoxProps
} from "./dashboardLayout";

export default function ResultsToViewPanel() {
  const { organisation } = useOrganisationContext();
  const { resolvedUrls } = useCmpRelatedUrl();

  const { data, loading } = useQuery(ORGANISATION_USER_TESTS_FOR_REVIEW_QUERY, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
    variables: {
      organisation: parseInt(organisation?.id, 10),
      page: 1,
      pageSize: cmpHomeDashboardListPageSize,
      orderBy: "-created"
    },
    skip: !organisation?.id
  });

  const userTests = data?.organisationUserTestsForReviewPagination?.items;

  return (
    <DashboardPanel
      title="Results to view"
      titleProps={cmpHomeDashboardPanelTitleProps}
      padding={cmpHomeDashboardPanelPadding}
      contentScrollProps={cmpHomeDashboardScrollableListBoxProps}
      headerStart={<ChartIcon size={60} iconSize={30} withCircle fill="#1A1A1A" />}
      headerStartGap={16}
      headerWrap
      headerEnd={
        <ButtonV2
          color="dark"
          size="xs"
          as={LinkWrapper}
          to={resolvedUrls[CMP_PATIENTS_NEW_RESULTS_URL]}
          rightIcon={<ChevronComponent />}
        >
          view all
        </ButtonV2>
      }
    >
      <ResultsToViewList userTests={userTests} loading={loading} />
    </DashboardPanel>
  );
}
